/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";
import { hideNavBar } from "@/common/common.js";

export function InitializeLenderSelectionPage() {
  customValidationInit(false);
  aspControlValidationInit();

  hideNavBar();
}
